import React from "react";
import { Alert, Box } from "@mantine/core";
import { AlertCircle } from "tabler-icons-react";

const AlertToast = ({
  showErrorAlert,
  setShowErrorAlert,
  showSuccessAlert,
  setShowSuccessAlert,
  setCustomErrorMessage,
  customErrorMessage,
}) => {
  let errorMessage;

  if (!customErrorMessage) {
    errorMessage = "Something weird happened! Try to refresh the folder list.";
  } else {
    errorMessage = customErrorMessage;
  }

  return (
    <Box maw="350px">
      {showErrorAlert && (
        <Alert
          icon={<AlertCircle size="1rem" />}
          title="Error!"
          color="red"
          withCloseButton
          onClose={() => {
            setShowErrorAlert(false);
            setCustomErrorMessage(undefined);
          }}
        >
          {errorMessage}
        </Alert>
      )}
      {showSuccessAlert && (
        <Alert
          icon={<AlertCircle size="1rem" />}
          title="Success!"
          color="green"
          withCloseButton
          onClose={() => setShowSuccessAlert(false)}
        >
          <h2>Message sent successfully! 🚀</h2>
        </Alert>
      )}
    </Box>
  );
};

export default AlertToast;
